import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef } from 'react';
import { PropTypes, describe } from 'react-desc';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import Circle from './Circle.js';
import '@elliemae/ds-system';
import 'polished';

var DSRadio = function DSRadio(_ref) {
  var containerProps = _ref.containerProps,
      className = _ref.className,
      style = _ref.style,
      labelText = _ref.labelText,
      htmlFor = _ref.htmlFor,
      hasError = _ref.hasError,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled,
      checked = _ref.checked,
      value = _ref.value,
      name = _ref.name,
      _onChange = _ref.onChange,
      children = _ref.children,
      tabIndex = _ref.tabIndex,
      otherProps = _objectWithoutProperties(_ref, ["containerProps", "className", "style", "labelText", "htmlFor", "hasError", "readOnly", "disabled", "checked", "value", "name", "onChange", "children", "tabIndex"]);

  var _convertPropToCssClas = convertPropToCssClassName('form-element-radio', className, {
    hasError: hasError,
    readOnly: readOnly,
    disabled: disabled
  }),
      cssClassName = _convertPropToCssClas.cssClassName,
      classNameElement = _convertPropToCssClas.classNameElement;

  var checkRef = useRef(null);
  return /*#__PURE__*/React.createElement("div", _extends({}, containerProps, {
    className: cssClassName
  }), /*#__PURE__*/React.createElement("label", {
    className: classNameElement('label'),
    htmlFor: htmlFor
  }, /*#__PURE__*/React.createElement("input", _extends({}, otherProps, {
    ref: checkRef,
    "aria-disabled": disabled,
    checked: disabled ? false : checked,
    className: classNameElement('input'),
    disabled: disabled,
    name: name,
    onChange: function onChange(e) {
      if (!readOnly && !disabled) {
        _onChange(e);
      }
    },
    readOnly: readOnly,
    tabIndex: -1,
    type: "radio",
    value: value
  })), /*#__PURE__*/React.createElement("span", {
    ref: otherProps.innerRef,
    "aria-checked": disabled ? false : checked,
    "aria-disabled": disabled,
    className: classNameElement('input-button'),
    onKeyDown: function onKeyDown(e) {
      e.target = checkRef.current;
      if (disabled) return;

      if (e.key === 'Enter' || e.keyCode === 32) {
        _onChange(e);
      } else if (otherProps.onKeyDown) {
        otherProps.onKeyDown(e);
      }
    },
    role: "radio",
    style: style,
    tabIndex: tabIndex,
    value: value
  }, /*#__PURE__*/React.createElement(Circle, {
    checked: checked
  })), /*#__PURE__*/React.createElement("span", {
    className: classNameElement('label-text')
  }, labelText)), children && /*#__PURE__*/React.createElement("div", {
    className: classNameElement('radio-children')
  }, children));
};

DSRadio.defaultProps = {
  containerProps: {},
  className: '',
  hasError: false,
  readOnly: false,
  disabled: false,
  checked: false,
  name: '',
  onChange: function onChange() {
    return null;
  },
  children: null,
  tabIndex: 0
};
var radioProps = {
  /** Injected props to wrapper element of component */
  containerProps: PropTypes.object.description('Injected props to wrapper element of component'),

  /** css class prop */
  className: PropTypes.string.description('css class prop'),

  /** name property to manage form */
  name: PropTypes.string.description('name property to manage form'),

  /**
   * Displayable label for the radio
   */
  labelText: PropTypes.string.description('Displayable label for the radio'),

  /** HTMLFOR property to manage form */
  htmlFor: PropTypes.element.description('HTMLFOR property to manage form'),

  /**
   * Whether the radio has error or not
   */
  hasError: PropTypes.bool.description('Whether the radio has error or not'),

  /**
   * Whether the radio is read only or not
   */
  readOnly: PropTypes.bool.description('Whether the radio is read only or not'),

  /**
   * Whether the radio is disabled or not
   */
  disabled: PropTypes.bool.description('Whether the radio is disabled or not'),

  /**
   * Whether the radio is checked or not
   */
  checked: PropTypes.bool.description('Whether the radio is checked or not'),

  /**
   * Value that takes the checkbox if it is checked
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired.description('Value that takes the checkbox if it is checked'),

  /**
   * Allows a function that is triggered once the radio changes
   */
  onChange: PropTypes.func.description('Allows a function that is triggered once the radio changes'),

  /**
   * Optional, if you want a checkbox customized
   */
  children: PropTypes.node.description('Optional, if you want a checkbox customized'),

  /** HTML tabindex to manage focus */
  tabIndex: PropTypes.object.description('HTML tabindex to manage focus'),

  /** style override object */
  style: PropTypes.number.description('style override object')
};
DSRadio.propTypes = radioProps;
var DSRadioWithSchema = describe(DSRadio).description('Radio button component');
DSRadioWithSchema.propTypes = radioProps;

export default DSRadio;
export { DSRadioWithSchema };
//# sourceMappingURL=DSRadio.js.map
